import { useAppContext } from 'contexts/appContext';
import { themes } from 'theme/themes';

export const useTheme = () => {
	const { brandCode } = useAppContext();

	return themes[brandCode];
};
